import { render } from "./VersionInfo.vue?vue&type=template&id=0947652e&scoped=true"
import script from "./VersionInfo.vue?vue&type=script&lang=js"
export * from "./VersionInfo.vue?vue&type=script&lang=js"

import "./VersionInfo.vue?vue&type=style&index=0&id=0947652e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0947652e"]])

export default __exports__